import React, {useState} from 'react'
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Tools from "../../../components/Tools/Tools";
import ManageDisbursmentHeader from "../../../components/Disbursment/ManageDisbursmentHeader";
import RoyaltyList from '../../../components/Reconciliation/Royalty/RoyaltyList';


const Royalty = () => {
    const {authData}=useSelector((state)=>state.authData);
    const [selectedTDS, setSelectednvoice]=useState([])
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchStr, setToSearchStr] = useState('');
    const [dateColumn, setDateColumn] = useState('voucher_date');


    const handleDateChange = (start, end, dateColumn, searchStr) => {
        setFromDate(start);
        setToDate(end);
        setToSearchStr(searchStr);
        setDateColumn(dateColumn);
    };

    return (
        <div>
            <div className='addNewScheme' >
                <div className="add_new_user">
                    <ManageDisbursmentHeader onDateChange={handleDateChange} startDate={fromDate} endDate={toDate} dateColumn={dateColumn} searchStr={searchStr} type={'Royalty'} />
                    <div>
                        <>
                            {selectedTDS.length>0 ? (
                                <Link to="/add-royalty" state={{data: selectedTDS }}>
                                    <button type="button" className="btn btn-primary">Add Challan</button>
                                </Link>
                            ):(
                                <button type="button" disabled={true} className="btn btn-primary">Add Challan</button>
                            )}
                        </>
                    </div>
                </div>
            </div>
            <div className='scheme p-3'>
                <RoyaltyList selectedInvoice={selectedTDS} setSelectednvoice={setSelectednvoice} fromDate={fromDate} toDate={toDate} dateColumn={dateColumn} searchStr={searchStr}/>
            </div>
        </div>
    )
}

export default Royalty
